import { boardImageApi } from '@/services/api';

export type BoardPart =
  | { kind: 'text'; text: string }
  | { kind: 'image'; file: string };

const imagePattern = () => /\{\{img:([a-zA-Z0-9._-]+)\}\}/g;
const cache = new Map<string, string>();

export const splitBoardBody = (value: string): BoardPart[] => {
  const parts: BoardPart[] = [];
  const source = String(value || '');
  let last = 0;
  for (const match of source.matchAll(imagePattern())) {
    const index = match.index || 0;
    if (index > last) parts.push({ kind: 'text', text: source.slice(last, index) });
    parts.push({ kind: 'image', file: match[1] });
    last = index + match[0].length;
  }
  if (last < source.length) parts.push({ kind: 'text', text: source.slice(last) });
  return parts.filter((part) => part.kind === 'image' || part.text.length > 0);
};

export const plainBoardText = (value: string) =>
  String(value || '').replace(imagePattern(), ' ').replace(/\s+/g, ' ').trim();

export const loadBoardImage = async (file: string) => {
  const cached = cache.get(file);
  if (cached) return cached;
  const res = await boardImageApi.fetch(file);
  const url = URL.createObjectURL(res.data);
  cache.set(file, url);
  return url;
};
